const basketball = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1_33430)">
      <path d="M17.0898 11H21.9498C21.7898 9.38998 21.2398 7.88998 20.4098 6.59998C18.6798 7.42998 17.4198 9.04998 17.0898 11Z" fill="black" />
      <path d="M6.9098 11C6.5798 9.04998 5.3198 7.42998 3.5898 6.59998C2.7598 7.88998 2.2098 9.38998 2.0498 11H6.9098Z" fill="black" />
      <path d="M15.07 11C15.39 8.40999 16.95 6.20999 19.13 4.99999C17.53 3.36999 15.39 2.28999 13 2.04999V11H15.07Z" fill="black" />
      <path d="M8.93012 11H11.0001V2.04999C8.61012 2.28999 6.46012 3.36999 4.87012 4.99999C7.05012 6.20999 8.61012 8.40999 8.93012 11Z" fill="black" />
      <path d="M15.07 13H13V21.95C15.39 21.71 17.54 20.63 19.13 19C16.95 17.79 15.39 15.59 15.07 13Z" fill="black" />
      <path d="M3.5898 17.4C5.3098 16.57 6.5798 14.94 6.9098 13H2.0498C2.2098 14.61 2.7598 16.11 3.5898 17.4Z" fill="black" />
      <path d="M17.0898 13C17.4198 14.95 18.6798 16.57 20.4098 17.4C21.2398 16.11 21.7898 14.61 21.9498 13H17.0898Z" fill="black" />
      <path d="M8.93012 13C8.61012 15.59 7.05012 17.79 4.87012 19C6.47012 20.63 8.61012 21.71 11.0001 21.95V13H8.93012Z" fill="black" />
    </g>
    <defs>
      <clipPath id="clip0_1_33430">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);
export default basketball;
